import gql from 'graphql-tag';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import HttpClient from '../../adapter/HttpClient';
import { OptimizerUserQuery, UserOptimizer } from '../../graphql/generated/graphql';

class UserWebApi {
  private graphqlClient: GraphQLClient;
  private httpClient: HttpClient;

  constructor({ graphqlClient, httpClient }: { graphqlClient: GraphQLClient; httpClient: HttpClient }) {
    this.graphqlClient = graphqlClient;
    this.httpClient = httpClient;
  }

  public getMe = async (): Promise<NonNullable<OptimizerUserQuery['me']>> => {
    let result: OptimizerUserQuery;

    try {
      result = await this.graphqlClient.query(
        gql`
          query optimizerUser {
            me {
              ... on UserOptimizer {
                id
                name
                email
                profileImageUrl
                personalInformationStatus
              }
            }
          }
        `,
      );
    } catch (err) {
      if (err instanceof GraphQLOperationFailed && err.type === 'KaizenAd::Exceptions::RecordNotFound') {
        throw new OptimizerUserNotFound();
      }

      throw err;
    }

    if (result.me) {
      return result.me;
    } else {
      throw Error('me is blank');
    }
  };

  public signUpAsOptimizer = async (): Promise<UserOptimizer> => {
    let response;
    try {
      response = await this.httpClient.post('/sign_up_optimizer', {});
    } catch (err) {
      if (err.type === 'KaizenAd::UserAlreadyExistsError') {
        throw new Error('message.already_registered_growth_hacker');
      }

      throw new Error('message.growth_hacker_registration_failed');
    }

    const user = response.data;

    return user;
  };
}

export class OptimizerUserNotFound extends Error {
  public readonly name = 'OptimizerUserNotFound';
  public readonly message: string;

  constructor() {
    super();

    this.message = `message.not_registered`;
  }
}

export default UserWebApi;
